// extracted by mini-css-extract-plugin
module.exports = {"instructions":"SpeakingChallenge_instructions__2vUCC"};